var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function toPositiveInt(value) {
    var n = Number(value);
    if (!Number.isFinite(n) || n <= 0)
        return null;
    return n;
}
export function normalizeAdminRole(role) {
    if (role && typeof role === 'object' && 'role' in role) {
        return normalizeAdminRole(role.role);
    }
    if (typeof role !== 'string')
        return '';
    return role.trim().replace(/_/g, ' ');
}
export function isUnrestrictedAdminRole(role) {
    var normalized = normalizeAdminRole(role);
    return normalized === 'системный администратор' || normalized === 'системный менеджер';
}
export function getManagedRestIds(userData) {
    var _a;
    var ids = new Set();
    if (Array.isArray(userData === null || userData === void 0 ? void 0 : userData.managedRestIds)) {
        for (var _i = 0, _b = userData.managedRestIds; _i < _b.length; _i++) {
            var id = _b[_i];
            var n = toPositiveInt(id);
            if (n)
                ids.add(n);
        }
    }
    var primary = toPositiveInt((_a = userData === null || userData === void 0 ? void 0 : userData.restaurant) === null || _a === void 0 ? void 0 : _a.id);
    if (primary)
        ids.add(primary);
    return __spreadArray([], ids, true);
}
export function hasRestaurantAccessRestriction(userData) {
    return getManagedRestIds(userData).length > 0;
}
export function canAccessRestaurant(userData, restaurantId) {
    if (isUnrestrictedAdminRole(userData === null || userData === void 0 ? void 0 : userData.role) || (userData === null || userData === void 0 ? void 0 : userData.isMiniAdmin)) {
        return true;
    }
    var target = toPositiveInt(restaurantId);
    if (!target)
        return false;
    var allowed = getManagedRestIds(userData);
    if (allowed.length === 0) {
        return true;
    }
    return allowed.includes(target);
}
export function userSharesRestaurantAccess(user, restaurantId) {
    var target = toPositiveInt(restaurantId);
    if (!target)
        return false;
    return getManagedRestIds(user).includes(target);
}
export function buildRestaurantAccessPayload(selectedRestaurants, required) {
    if (required === void 0) {
        required = false;
    }
    if (selectedRestaurants.length === 0) {
        return required ? null : null;
    }
    var ids = selectedRestaurants.map(function (item) { return item.id; });
    return {
        restId: ids[0],
        managedRestIds: ids,
    };
}
export function resolveUserRestaurants(editedUser, catalog) {
    if (catalog === void 0) {
        catalog = [];
    }
    var ids = getManagedRestIds(editedUser);
    if (!ids.length) {
        return [];
    }
    var fromCatalog = catalog.filter(function (item) { return ids.includes(Number(item.id)); });
    var foundIds = new Set(fromCatalog.map(function (item) { return Number(item.id); }));
    var fallback = ids
        .filter(function (id) { return !foundIds.has(id); })
        .map(function (id) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (Number((_a = editedUser.restaurant) === null || _a === void 0 ? void 0 : _a.id) === id) {
            return {
                id: id,
                name: (_b = editedUser.restaurant.name) !== null && _b !== void 0 ? _b : "\u0417\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0435 #".concat(id),
                address: (_c = editedUser.restaurant.address) !== null && _c !== void 0 ? _c : '',
                phone: (_d = editedUser.restaurant.phone) !== null && _d !== void 0 ? _d : '',
                email: (_e = editedUser.restaurant.email) !== null && _e !== void 0 ? _e : '',
                telegram: (_f = editedUser.restaurant.telegram) !== null && _f !== void 0 ? _f : '',
                ownerName: (_g = editedUser.restaurant.ownerName) !== null && _g !== void 0 ? _g : '',
                restBalance: (_h = editedUser.restaurant.restBalance) !== null && _h !== void 0 ? _h : 0,
            };
        }
        return {
            id: id,
            name: "\u0417\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0435 #".concat(id),
            address: '',
            phone: '',
            email: '',
            telegram: '',
            ownerName: '',
            restBalance: 0,
        };
    });
    return __spreadArray(__spreadArray([], fromCatalog, true), fallback, true);
}
export function getEstablishmentQueryScope(role, userData) {
    var _a;
    if (isUnrestrictedAdminRole(role)) {
        return {};
    }
    var managedRestIds = getManagedRestIds(userData);
    if (managedRestIds.length > 1) {
        return {
            role: role,
            managedRestIds: managedRestIds.join(','),
            userRestId: managedRestIds[0],
        };
    }
    if (managedRestIds.length === 1) {
        return {
            role: role,
            userRestId: managedRestIds[0],
        };
    }
    if (role === 'сотрудник') {
        return {
            role: role,
            userRestId: toPositiveInt((_a = userData === null || userData === void 0 ? void 0 : userData.restaurant) === null || _a === void 0 ? void 0 : _a.id) || 0,
        };
    }
    return {};
}
